import React, { useEffect, useMemo, useState } from "react";
import RfmModalBase from "./RfmModalBase";

export default function RfmAddOrderToComensalModal({
  open,
  onClose,
  onAdd,
  getAvailableItemsByOrder,
  dinerName = "",
  orderOptions = [],
  preselectedOrderId = "",
}) {
  const [selectedItems, setSelectedItems] = useState([]);
  const [orderId, setOrderId] = useState(preselectedOrderId || "");

  useEffect(() => {
    if (open) {
      setOrderId(preselectedOrderId || orderOptions?.[0]?.id || "");
      return;
    }

    setSelectedItems([]);
    setOrderId("");
  }, [open, preselectedOrderId, orderOptions]);

  useEffect(() => {
    setSelectedItems([]);
  }, [orderId]);

  const availableItems = useMemo(() => {
    if (!orderId || !getAvailableItemsByOrder) return [];
    return getAvailableItemsByOrder(orderId) || [];
  }, [orderId, getAvailableItemsByOrder]);

  const canSubmit = useMemo(() => selectedItems.length > 0 && !!orderId, [selectedItems, orderId]);

  const toggleItem = (item) => {
    const key = `${item.source}_${item.index}`;
    setSelectedItems((prev) =>
      prev.some((x) => `${x.source}_${x.index}` === key)
        ? prev.filter((x) => `${x.source}_${x.index}` !== key)
        : [...prev, item]
    );
  };

  const submit = () => {
    if (!canSubmit) return;
    onAdd?.({ items: selectedItems, order_id: orderId });
  };

  return (
    <RfmModalBase
      open={open}
      title={`Asignar pedidos a ${dinerName || "comensal"}`}
      onClose={onClose}
      footer={
        <>
          <button className="rfm-btn rfm-btn-secondary" type="button" onClick={onClose}>
            Cancelar
          </button>
          <button className="rfm-btn rfm-btn-primary" type="button" onClick={submit} disabled={!canSubmit}>
            <i className="bi bi-check2" /> Asignar
          </button>
        </>
      }
    >
      <div className="rfm-form-group">
        <label className="rfm-form-label">Orden</label>
        <select
          className="rfm-form-input"
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
        >
          <option value="">Seleccione una orden</option>
          {orderOptions.map((ord) => (
            <option key={ord.id} value={ord.id}>
              {ord.label}
            </option>
          ))}
        </select>
      </div>

      <div className="rfm-form-group">
        <label className="rfm-form-label">Productos sin asignar</label>

        {availableItems.length === 0 ? (
          <div className="rfm-empty">No hay productos disponibles para asignar</div>
        ) : (
          <div className="rfm-comensales-list">
            {availableItems.map((item) => {
              const key = `${item.source}_${item.index}`;
              const checked = selectedItems.some((x) => `${x.source}_${x.index}` === key);

              return (
                <label
                  key={key}
                  className="rfm-comensal-order"
                  style={{ cursor: "pointer", justifyContent: "space-between" }}
                >
                  <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => toggleItem(item)}
                    />
                    <span>
                      {item.source === "combo" ? "🥡" : "🍽️"} {item.name} x{item.qty}
                    </span>
                  </div>

                  <span className="rfm-comensal-order-price">
                    ${(Number(item.price || 0) * Number(item.qty || 1)).toFixed(2)}
                  </span>
                </label>
              );
            })}
          </div>
        )}
      </div>
    </RfmModalBase>
  );
}